import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { collection, onSnapshot, query } from '@firebase/firestore';
import { Unsubscribe } from '@firebase/util';
import { Subject } from 'rxjs';
import { LoadingService } from '../loading.service';
import { Book } from './book';
import { AngularFireStorage } from '@angular/fire/compat/storage';

@Injectable({
  providedIn: 'root'
})
export class BooksService {

  constructor(public firestore: AngularFirestore, public loadingService: LoadingService, private storage: AngularFireStorage,) { this.getBooks() }
  
  keepFocus = false
  addingNewBook = false
  selectedBook?: Book
  db = this.firestore.firestore
  booksListener?: Unsubscribe
  private allBooks = new Subject<any>();
  public allBooks$ = this.allBooks.asObservable();

  getBooks() {
    if (this.booksListener != null) {
      return
    }

    const q = query(collection(this.db, "books"));
    this.booksListener = onSnapshot(q, (querySnapshot) => {
      const snapshotBooks: Book[] = []
      querySnapshot.forEach((doc) => {
        const data = doc.data()
        const uid = doc.id
        const title = data["title"]
        const summary = data["summary"]
        const author = data["author"]
        const purchaseLink = data["purchaseLink"]

        const book = { uid, title, summary, author, purchaseLink } as Book
        snapshotBooks.push(book)
      });
      snapshotBooks.sort((a, b) => a.title < b.title ? -1 : 1);
      this.allBooks.next(snapshotBooks)
    },
      (error) => {
        alert(error)
        throw(error)
      });;
  }
  
  addBookCancelled() {
    this.addingNewBook = false
    this.keepFocus = false
  }

  async addNewBook(book: Book, loadingKey: string, file?: File) {
    const newBookDoc = this.db.collection("books").doc();
    var bookToPost = Object(book)

    delete bookToPost.uid
    bookToPost["dateAdded"] = new Date()

    if (file != null && file != undefined) {
        const fileExtension = this.returnFileType(file.name)
        const titleEncoded = book.title.replace(/[^a-z0-9]/gi, '_').toLowerCase();
        const fileName = `${titleEncoded}.${fileExtension}`
        const filePath = `bookPhotos/${fileName}`;
        const ref = this.storage.ref(filePath);
        await ref.put(file);
        bookToPost["picFileName"] = fileName
    }

    newBookDoc.set(bookToPost)
    .then(response => {
      this.keepFocus = false
      this.loadingService.removeLoadingKey(loadingKey)
      this.addingNewBook = false
      this.selectedBook = undefined
      alert("Book added successfully")
    })
    .catch(e => {
      this.loadingService.removeLoadingKey(loadingKey)
      alert(e)
      throw(e)
    });
  }

  async updateBook(book: Book, newfile?: File) {
    const loadingKey = book.uid!!
    this.loadingService.addLoadingKey(loadingKey)
    const bookDoc = this.db.collection("books").doc(book.uid);
    
    var bookToPost = Object(book)
    delete bookToPost.uid

    if (newfile != null && newfile != undefined) {
        const fileExtension = this.returnFileType(newfile.name)
        const fileName = `${book.title}.${fileExtension}`
        const filePath = `bookPhotos/${fileName}`;
        const ref = this.storage.ref(filePath);
        await ref.put(newfile);
        bookToPost["picFileName"] = fileName
    }

    bookDoc.update(bookToPost)
    .then(response => {
      this.keepFocus = false
      this.loadingService.removeLoadingKey(loadingKey)
      this.addingNewBook = false
      this.selectedBook = undefined
      alert("Book Updated successfully")
    })
    .catch(e => {
      this.loadingService.removeLoadingKey(loadingKey)
      alert(e)
      throw(e)
    });
  }

  async deleteBook(book: Book) {
    const loadingKey = book.title
    this.loadingService.addLoadingKey(loadingKey)
    const bookDoc = this.db.collection("books").doc(book.uid);
    
    bookDoc.delete()
    .then(response => {
      this.keepFocus = false
      this.loadingService.removeLoadingKey(loadingKey)
      this.addingNewBook = false
      this.selectedBook = undefined
      alert("Book Removed successfully")
    })
    .catch(e => {
      this.loadingService.removeLoadingKey(loadingKey)
      alert(e)
      throw(e)
    });
  }

  returnFileType(fileName: string) {
    return fileName.split('.').pop();
  }


//FIXME: - fire this
  signout() {
    if (this.booksListener != null) {
      this.booksListener()
    }
  }
}
